import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import api from "../utils/api";

export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [msg, setMsg] = useState("Confirming payment with Stripe…");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); setMsg("Missing session id."); return; }
    let attempts = 0;
    const MAX = 8;
    const poll = async () => {
      try {
        const r = await api.get(`/billing/checkout/${sessionId}/status`);
        if (r.data.payment_status === "paid") {
          setStatus("success");
          setMsg("Payment received. Your account is being activated — you'll get a confirmation email within a few minutes.");
          return;
        }
        if (r.data.status === "expired") {
          setStatus("error"); setMsg("This checkout session expired. Please try again from the pricing page."); return;
        }
        attempts += 1;
        if (attempts >= MAX) { setStatus("pending"); setMsg("Payment is still being processed. Check your email — we'll confirm as soon as Stripe settles."); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setStatus("error"); setMsg(e.response?.data?.detail || e.message || "Couldn't confirm payment.");
      }
    };
    poll();
  }, [sessionId]);

  const Icon = status === "success" ? CheckCircle2 : status === "error" ? AlertTriangle : Loader2;
  const color = status === "success" ? "var(--sage)" : status === "error" ? "#B91C1C" : "var(--sage)";

  return (
    <div data-testid="checkout-success-page" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem", background: "var(--bg-default)" }}>
      <div style={{ background: "white", padding: "2.5rem", borderRadius: 16, maxWidth: 500, width: "100%", textAlign: "center", border: "1px solid var(--border-default)" }}>
        <Icon size={42} style={{ color, margin: "0 auto 1rem", animation: status === "checking" ? "spin 1s linear infinite" : "none" }} />
        <h1 style={{ margin: "0 0 0.6rem", fontFamily: "Bricolage Grotesque, sans-serif", fontWeight: 700, fontSize: "1.4rem" }}>
          {status === "success" ? "You're all set" : status === "error" ? "Something went wrong" : status === "pending" ? "Almost there" : "Just a moment"}
        </h1>
        <p style={{ color: "var(--text-secondary)", fontSize: "0.92rem", lineHeight: 1.6, margin: "0 0 1.5rem" }}>{msg}</p>
        <button onClick={() => nav("/")} className="btn-primary" style={{ padding: "0.6rem 1.4rem", fontSize: "0.88rem" }}>
          Back to home
        </button>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}
